import { render, staticRenderFns } from "./device_detail_supplies.vue?vue&type=template&id=48e12967"
import script from "./device_detail_supplies.vue?vue&type=script&lang=js"
export * from "./device_detail_supplies.vue?vue&type=script&lang=js"
import style0 from "./device_detail_supplies.vue?vue&type=style&index=0&id=48e12967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports